<template>
  <div class="category-management">
    <page-title title="筛选">
      <el-row class="category-management__filter-header" :gutter="20">
        <el-col :xl="4" :span="6">
          <span>流水号：</span>
          <el-input v-model="filter.flowNum" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>消费说明：</span>
          <el-input v-model="filter.description" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>消费类型：</span>
          <el-select v-model="filter.consumeTypeId" placeholder="请输入" clearable filterable>
            <el-option v-for="item in payOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :xl="6" :span="8">
          <span>消费时间：</span>
          <el-date-picker v-model="filter.dateTime" type="datetimerange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
            :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-col>

        <el-col :xl="3" :span="6">
          <el-button @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
          <el-button type="primary" @click="handleExport">下载</el-button>
        </el-col>
      </el-row>
    </page-title>
    <page-title title="数据列表">
      <div class="category-management__body">
        <el-table v-loading="loading" :data="tableData" style="width: 100%"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }">
          <el-table-column prop="flowNum" label="流水号"></el-table-column>
          <el-table-column prop="description" label="消费说明"></el-table-column>
          <el-table-column label="消费类型">
            <template slot-scope="scope">
              {{ scope.row.consumeType.consumeType }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="消费时间">
            <template slot-scope="scope">
              {{ formatterDate(scope.row.createdDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="consumeCount" label="消费数量"></el-table-column>
          <el-table-column prop="guobanCurrecyConsumption" label="消耗国版币"></el-table-column>
          <el-table-column prop="value" label="价值">
            <template slot-scope="scope">
              <span v-if="scope.row.description === '退款'">-</span>
              <span v-else>{{ scope.row.value }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="operator" label="操作员"></el-table-column>
        </el-table>
        <cus-pagination :total="total" :current-page.sync="currentPage" :page-size.sync="pageSize"
          @size-change="getList"></cus-pagination>
      </div>
    </page-title>
  </div>
</template>

<script>
import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import axios from 'axios';
import {
  getPicturePageList,
  festiveAdd,
  festiveEdit,
  festiveUpAndDown,
  festiveDel,
} from "@/api/page";
import { currencyList, getAllConsumeType, exportConsumeDetail } from "@/api/package";
import { Message } from "element-ui";
import { scope } from "@/config/config";
import dayjs from "dayjs";
import { requestUrl } from '../../../config/config';
export default {
  components: {
    PageTitle,
    CusPagination,
  },
  data() {
    return {
      apiEnd: false,
      loading: true,
      filter: {
        flowNum: "",
        description: "",
        consumeTypeId: "",
        dateTime: [],
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogMode: "add", // 默认模式
      currentData: {}, // 当前表单数据
      payOptions: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {},
  watch: {
    currentPage() {
      this.getList();
    },
  },
  methods: {
    formatterDate(cellValue) {
      return dayjs(cellValue).format("YYYY-MM-DD HH:mm:ss");
    },
    async getList() {
      this.loading = true;
      const { data } = await this.$ajax.get(currencyList, {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        flowNum: this.filter.flowNum,
        description: this.filter.description,
        consumeTypeId: this.filter.consumeTypeId,
        startDate: this.filter.dateTime ? this.filter.dateTime[0] : "",
        endDate: this.filter.dateTime ? this.filter.dateTime[1] : "",
      });
      this.tableData = data?.rows || [];
      this.total = data?.total || 0;
      this.loading = false;
    },
    search() {
      this.getList();
    },
    reset() {
      this.filter.flowNum = "";
      this.filter.description = "";
      this.filter.dateTime = [];
      this.filter.consumeTypeId = "";
      this.getList();
    },
    getAllConsumeType() {
      this.$ajax.get(getAllConsumeType()).then((res) => {
        this.payOptions = res.data.map((item) => {
          return {
            value: item.id,
            label: item.consumeType,
          };
        });
      });
    },
    handleExport() {
      this.exportLoading = true;
      const params = {
        flowNum: this.filter.flowNum,
        description: this.filter.description,
        consumeTypeId: this.filter.consumeTypeId,
        startDate: this.filter.dateTime ? this.filter.dateTime[0] : "",
        endDate: this.filter.dateTime ? this.filter.dateTime[1] : "",
      }
      axios({
        url: requestUrl + exportConsumeDetail,
        method: 'get',
        params: params,
        responseType: 'blob',
        headers: {
          Authorization: 'Bearer ' + sessionStorage.getItem('token')
        }
      }).then(res => {
        if (!res) return;
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel,charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = '消费明细.xlsx';
        a.click();
        URL.revokeObjectURL(url);
      })
    },
  },
  mounted() {
    this.getAllConsumeType();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.category-management {
  .box-card {
    margin-bottom: 20px;
  }

  &__filter-header {
    display: flex;
    align-items: center;
  }

  &__body {
    .edit {
      color: #005bff;
    }

    .el-button.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }

    .el-switch__label {
      color: #333333;
    }

    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
  }
}
</style>
